import React from 'react'
import CouponV7b from './CouponVersion/CouponV7b'
import CouponV1 from './CouponVersion/CouponV1'
import CouponV7 from './CouponVersion/CouponV7'

class CouponSPA extends React.Component{

    renderContent(){
        const version = this.props.location.query.version!==undefined ? this.props.location.query.version : '1'
            switch (version) {
                case '1':
                    return <CouponV1 {...this.props}/>
                case '7B':
                    return <CouponV7b {...this.props}/>
                case '7A':
                    return <CouponV7 {...this.props}/>
                case '7C':
                    return <CouponV7 {...this.props}/>
                default:
                    return <CouponV1 {...this.props}/>
            }
    }

    render(){
        return(
            <div>
                {this.renderContent()}
            </div>
        )
    }
}

export default  CouponSPA


// WEBPACK FOOTER //
// ./src/pages/ActivityPage/Coupon/CouponSPA.js